import React from 'react';
import {
    Badge,
    Box,
    List,
    ListItem,
    Progress,
    Text,
} from '@chakra-ui/react';

import data from '../../data/asignaturas.json';

export function Ingenieria() {

    return (
        <>
            <Text
                fontSize="2xl"
                fontWeight="bold"
                color="white"
                mb={2}
            >
                {data.titulo}
            </Text>

            <Progress
                value={data.progreso}
                w="80%"
                size="sm"
                colorScheme="green"
                hasStripe
                isAnimated
                mb={5}
            />

            <List>
                {data.asignaturas.map((asig, index) => (
                    <ListItem key={index} mb={2}>
                        <Badge mr={2}>{asig.tipo}</Badge>
                        <Badge mr={2}>{asig.creditos}</Badge>
                        <Badge mr={2} bg={asig.colorFondo}>
                            Sem. {asig.semestre}
                        </Badge>
                        <Badge mr={2}>{asig.codigo}</Badge>
                        {asig.nombre}
                    </ListItem>
                ))}
            </List>

            <Box mb={5} />
        </>
    );
}